module.exports = __webpack_public_path__ + "static/media/bladderiet.c8334b09.png";